<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Detalhes da compra" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && compra">
      <px-compra-detalhes-dados-basicos :compra="compra" @movimentar="onMovimentar"/>
      <px-compra-detalhes-tabs :compra="compra"/>
      <px-compra-detalhes-produtos :compra="compra"/>
      <px-compra-detalhes-mensagens-personalizadas v-if="checkMessages"
                                                   :compra="compra"/>
      <px-compra-mensagem class="mt-3" :compra="compra" v-if="compra.fornecedor.hasUsers"/>
      <px-compra-detalhes-logs :id-compra="compra.id" v-if="hasIntegracaoAtiva"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompraDetalhesDadosBasicos from './CompraDetalhesDadosBasicos.vue';
import CompraDetalhesLogs from './logs-compra/CompraDetalhesLogs.vue';
import CompraDetalhesProdutos from './CompraDetalhesProdutos.vue';
import CompraDetalhesTabs from './CompraDetalhesTabs.vue';
import CompraMensagem from '../CompraMensagem.vue';
import CompraService from '../compra-service';
import CompraDetalhesMensagensPersonalizadas from './CompraDetalhesMensagensPersonalizadas.vue';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    compraIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      compra: null,
      loading: false,
      compraId: null,
      backLink: this.$route.query.backLink,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Compras', to: '/compras' },
        { text: 'Detalhes' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasIntegracaoAtiva']),
    checkMessages() {
      return this.compra.mensagensPersonalizadas
      && this.compra.mensagensPersonalizadas.length;
    },
  },
  methods: {
    onClickBack() {
      if (this.backLink) {
        this.$router.push({ path: this.backLink });
        return;
      }
      this.$router.push({ name: 'main.compras' });
    },
    getCompra() {
      this.loading = true;
      CompraService.getCompraCompleto(this.compraId)
        .then((response) => {
          this.compra = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onMovimentar() {
      this.getCompra();
    },
  },
  created() {
    this.compraId = this.compraIdProp || this.$route.params.id;
    this.getCompra();
  },
  components: {
    pxCompraDetalhesDadosBasicos: CompraDetalhesDadosBasicos,
    pxCompraDetalhesProdutos: CompraDetalhesProdutos,
    pxCompraDetalhesTabs: CompraDetalhesTabs,
    pxCompraMensagem: CompraMensagem,
    pxCompraDetalhesLogs: CompraDetalhesLogs,
    pxCompraDetalhesMensagensPersonalizadas: CompraDetalhesMensagensPersonalizadas,
  },
};
</script>
